import styles from "../../styles/components/AdminPage.module.css";

export type FeedbackEntry = { id: string; text: string; timestamp: string };

interface Props {
  entries: FeedbackEntry[] | null;
  loading: boolean;
  deleting: Set<string>;
  onLoad: () => void;
  onDelete: (id: string) => void;
}

export function FeedbackTable({ entries, loading, deleting, onLoad, onDelete }: Props) {
  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <h2 className={styles.panelTitle}>User Feedback</h2>
        <button
          type="button"
          className={`${styles.viewToggleBtn} ${loading ? "" : styles.viewToggleBtnActive}`}
          onClick={onLoad}
          disabled={loading}
        >
          {loading ? "Loading…" : "Load Feedback"}
        </button>
      </div>
      <div className={styles.panelBody}>
        {entries === null ? (
          <span className={styles.panelEmpty}>Click "Load Feedback" to view submissions.</span>
        ) : entries.length === 0 ? (
          <span className={styles.panelEmpty}>No feedback received yet!</span>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Feedback</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id}>
                  <td style={{ whiteSpace: "nowrap", width: "1%" }}>
                    {new Date(e.timestamp).toLocaleString()}
                  </td>
                  <td style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{e.text}</td>
                  <td style={{ width: "1%" }}>
                    <button
                      type="button"
                      className={styles.opBtn}
                      disabled={deleting.has(e.id)}
                      onClick={() => onDelete(e.id)}
                    >
                      {deleting.has(e.id) ? "…" : "Clear"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
